import { Card } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { PulseLoader } from 'react-spinners'
import { useParams } from 'react-router-dom'

import '../styles/geist-font.css'
import '../styles/direct-debit-responsive.css'
import { SESSION_FUNDING_SOURCE_PAGES } from '../constants/SessionConstants'
import { SessionContextProvider, useSession } from '../contexts/SessionContext'
import { DirectDebitStatusContextProvider } from '../contexts/session/DirectDebitContext'

import Footer from '../components/layout/Footer'
import Header from '../components/layout/v2/Header'

const SessionPage = () => {
  const { sessionId } = useParams()
  const {
    currentFundingSource,
    sessionData,
    setSessionId,
    loadSessionData,
    setCurrentFundingSource,
  } = useSession()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (sessionId) {
      setSessionId(sessionId)
      loadSessionData(sessionId).finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [])

  // Determine the funding source from session data if not already set
  useEffect(() => {
    if (sessionData && !currentFundingSource)
      setCurrentFundingSource(sessionData.fundingType)
  }, [sessionData, currentFundingSource])

  const renderFundingSourceComponent = () => {
    return (
      <>
        <Card
          style={{
            maxWidth: 'var(--dd-card-max-width)',
            height: 'var(--dd-card-max-height)',
            maxHeight: 'var(--dd-card-max-height)',
            borderRadius: 'var(--dd-card-radius)',
            overflow: 'hidden',
          }}
        >
          <Card.Header
            style={{
              borderBottom: '1px solid #EAECF0',
              padding: 'var(--dd-header-padding-y) var(--dd-header-padding-x)',
            }}
            className='bg-white'
          >
            <Header />
          </Card.Header>

          <Card.Body style={{ overflowY: 'auto', minHeight: 0 }}>
            {SESSION_FUNDING_SOURCE_PAGES[
              currentFundingSource?.toUpperCase()
            ] || <div>Unknown funding source</div>}
          </Card.Body>
        </Card>
        <Footer />
      </>
    )
  }

  return (
    <div style={{ backgroundColor: '#26262680', padding: 'var(--dd-outer-padding)' }} className='checkout vh-100 dd-modal'>
      {loading ? (
        <PulseLoader size={10} speedMultiplier={0.7} color={'#f7931e'} />
      ) : (
        renderFundingSourceComponent()
      )}
    </div>
  )
}

const SessionWrapper = () => {
  return (
    <SessionContextProvider>
      <DirectDebitStatusContextProvider>
        <SessionPage />
      </DirectDebitStatusContextProvider>
    </SessionContextProvider>
  )
}

export default SessionWrapper
